import { getEnvironment } from "./utils";

export const getEngagementSurveyURLPrefix = () => {
	const environment = getEnvironment();

	if (environment === "localhost") {
		return `http://localhost:5173`;
	} else if (environment === "production") {
		return `https://engagement.talent.performyard.com`;
	}

	return `https://engagement.${environment}.talent.performyard.com`;
};
